import { apiClient } from "../../../lib/axios";
import { LiveProgressResponse, ProjectsResponse } from "./types";

export const liveProgressApi = {
  fetchLiveProgress: async (params: string | undefined): Promise<LiveProgressResponse> => {
    const response = await apiClient.get(`/live-progress?is_construction=${params}`);
    return response.data;
  },
  fetchProjects: async (params?: {
    page?: number;
    limit?: number;
  }): Promise<ProjectsResponse> => {
    const response = await apiClient.get("/projects", { params });
    return response.data;
  },
};

